exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ntable[data-v-4f575612] {\n    table-layout: fixed !important;\n}\n\n", ""]);

// exports
